import { observer } from 'mobx-react-lite';

import { Button } from '@components/button';
import { Text } from '@components/text';

import { Modal } from 'features/modals';
import { useStore } from 'models/Provider';

export const NotifyTwoFactor = observer(({ disable, remove, closeModal }) => {
  const { t } = useStore();
  return (
    <Modal>
      <Modal.Header text={t('modals.notifytwofactor.header')} />
      <Text text={t('modals.notifytwofactor.text')} />
      <Modal.Actions>
        <Button onClick={closeModal} text={t('modals.notifytwofactor.button.close')} />
      </Modal.Actions>
    </Modal>
  );
});
